export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/mall-service-advantage-d06d5793e2169a79055549ab6df6bc34.png";